import React from 'react'
import AdminVehicleNew from '../../components/admin/vehicles/admin-vehicle-new'
import AdminTemplate from '../../templates/admin-template'


const AdminVehiclesNewPage = () => {
  return (
    <AdminTemplate>
        <AdminVehicleNew/>
    </AdminTemplate>
  )
}

export default AdminVehiclesNewPage